module.exports = __webpack_public_path__ + "img/binance.ddc26cef.png";